<template>
  <v-dialog v-model="dialog" persistent fullscreen width="1400">
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <div class="px-2 pt-4">
        <div
          class="pb-4 px-3"
          :class="!this.$vuetify.breakpoint.mobile && 'd-flex'"
          :style="{
            gap: !this.$vuetify.breakpoint.mobile && '72px',
            'font-size': this.$vuetify.breakpoint.mobile ? '14px' : '18px',
          }"
        >
          <div>
            <v-icon
              :size="$vuetify.breakpoint.mobile ? 16 : 24"
              class="mr-1 mb-1"
            >
              mdi-account
            </v-icon>
            <span class="grey--text">{{ $t("agent") }}:</span>
            {{ affiliateData.name }}
          </div>
          <div>
            <v-icon
              :color="handleColorStatus(affiliateData.status)"
              :size="$vuetify.breakpoint.mobile ? 16 : 24"
              class="mr-1"
            >
              mdi-circle
            </v-icon>
            <span class="grey--text">ID: </span> {{ idAffiliate }}
          </div>
          <div
            class="d-flex align-center"
            v-if="totalActiveAffiliated && totalActiveAffiliated > 0"
          >
            <v-icon
              :size="$vuetify.breakpoint.mobile ? 16 : 24"
              color="#0950D9"
            >
              mdi-account
            </v-icon>
            <span class="grey--text">{{ $t("activePlayers") }}:</span>
            {{ totalActiveAffiliated }}
          </div>
        </div>
        <Range />
        <div class="mx-2 mb-3">
          <GroupExport />
        </div>
      </div>
      <v-card-actions class="px-4 pt-0">
        <v-spacer></v-spacer>
        <v-btn
          v-if="exportDoc"
          class="info"
          small
          @click="fetchAnalyticsDataByAffiliate()"
          :disabled="progress"
        >
          <v-icon small left>mdi-tray-arrow-down</v-icon>
          {{ language == "pt" ? $t("downloadPt") : $t("download") }}
        </v-btn>
        <v-btn
          v-else
          class="info"
          small
          @click="fetchAnalyticsDataByAffiliate()"
          :disabled="progress"
        >
          <v-icon small left>mdi-filter</v-icon> {{ $t("toFilter") }}
        </v-btn>
      </v-card-actions>

      <v-divider></v-divider>

      <div v-show="progress && !analyticsReportData" class="text-center pa-4">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>

      <v-row
        class="mx-auto mt-8"
        :style="{
          width: $vuetify.breakpoint.mobile ? '' : '80%',
        }"
      >
        <v-col
          v-show="!progress"
          :cols="
            !analyticsReportData &&
            totalActiveAffiliated &&
            !$vuetify.breakpoint.mobile
              ? 4
              : $vuetify.breakpoint.mobile
              ? 12
              : !totalActiveAffiliated
              ? 6
              : 2
          "
          class="mx-auto"
        >
          <v-card
            v-if="totalActiveAffiliated && false"
            class="d-flex flex-column align-center justify-center"
            style="box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);"
            :style="{
              'border-radius': '10px',
              background: $vuetify.theme.dark ? '#252525' : '',
              height:
                analyticsReportData && !$vuetify.breakpoint.mobile
                  ? '220px'
                  : $vuetify.breakpoint.mobile
                  ? '90px'
                  : '183px',
              'margin-top':
                !$vuetify.breakpoint.mobile && analyticsReportData
                  ? '54px'
                  : '',
            }"
          >
            <div class="d-flex flex-row align-center">
              <v-icon
                :size="$vuetify.breakpoint.mobile ? 32 : 40"
                color="#0950D9"
              >
                mdi-account
              </v-icon>
              <div
                class="ml-2 font-weight-medium"
                :style="{
                  'font-size': $vuetify.breakpoint.mobile ? '24px' : '30px',
                }"
              >
                {{ totalActiveAffiliated }}
              </div>
            </div>
            <div style="font-size: 14px">
              {{ $t("activePlayers", totalActiveAffiliated) }}
            </div>
          </v-card>

          <v-alert
            v-if="errorMsg && !progress"
            dense
            color="#DC5E1833"
            class="d-flex justify-center"
            :class="totalActiveAffiliated ? 'mt-8' : 'mt-0'"
            style="font-size: 14px;"
          >
            <div
              class="d-flex text-center align-center"
              :class="$vuetify.breakpoint.mobile && 'flex-column'"
            >
              <v-icon
                color="#DC5E18"
                :style="{
                  'margin-right': $vuetify.breakpoint.mobile ? '' : '22px',
                  'margin-bottom': $vuetify.breakpoint.mobile ? '8px' : '',
                }"
              >
                mdi-alert
              </v-icon>
              {{ errorMsg }}
            </div>
          </v-alert>
        </v-col>
        <v-col
          v-if="!!analyticsReportData"
          :cols="$vuetify.breakpoint.mobile ? 12 : 10"
        >
          <div class="d-flex align-center mb-6" style="font-size: 20px">
            {{ $t("transactions") }}
            <v-divider class="ml-2"></v-divider>
          </div>

          <AnalyticalReportCard
            :type="['depositQty', 'withdrawQty']"
            :amounts="[
              analyticsReportData.quantity_deposit,
              analyticsReportData.quantity_withdraw,
            ]"
          />

          <AnalyticalReportCard
            :type="['deposit', 'withdraw']"
            :values="[
              analyticsReportData.value_deposit,
              analyticsReportData.value_withdraw,
            ]"
            :marginBottom="true"
          />

          <div class="d-flex align-center mb-6" style="font-size: 20px">
            {{ $t("sports") }}
            <v-divider class="ml-2"></v-divider>
          </div>

          <AnalyticalReportCard
            :type="['betsQty', 'betsPrizeQty']"
            :amounts="[
              analyticsReportData.quantity_bet,
              analyticsReportData.quantity_prizes,
            ]"
          />

          <AnalyticalReportCard
            :type="['bets', 'betsPrize']"
            :values="[
              analyticsReportData.value_bet,
              analyticsReportData.value_prizes,
            ]"
            :marginBottom="true"
          />

          <div
            v-if="hasCasino"
            class="d-flex align-center mb-6"
            style="font-size: 20px"
          >
            {{ $t("casino") }}
            <v-divider class="ml-2"></v-divider>
          </div>

          <AnalyticalReportCard
            v-if="hasCasino"
            :type="['betCasinoQty', 'prizesCasinoQty']"
            :amounts="[
              analyticsReportData.quantity_bet_casino,
              analyticsReportData.quantity_prize_casino,
            ]"
          />

          <AnalyticalReportCard
            v-if="hasCasino"
            :type="['betCasino', 'prizesCasino']"
            :values="[
              analyticsReportData.value_bet_casino,
              analyticsReportData.value_prizes_casino,
            ]"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import Range from "@/components/common/filters/Range.vue";
import GroupExport from "@/components/common/filters/GroupExport.vue";
import AnalyticalReportCard from "./AnalyticalReportCard.vue";

export default {
  name: "analytical-report-affiliate",
  components: { Range, GroupExport, AnalyticalReportCard },
  data: () => ({
    affiliateData: {},
    totalActiveAffiliated: null,
    analyticsReportData: null,
    progress: false,
    errorMsg: null,
  }),
  computed: {
    idAffiliate() {
      return this.$route.params.id;
    },
    dialog() {
      return this.$store.state.showDialog;
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    hasCasino() {
      const casinoValues = Object.entries(
        this.analyticsReportData
      ).filter((item) => item[0].includes("casino"));
      return casinoValues.find((value) => value[1] > 0);
    },
    language() {
      return localStorage.getItem("language");
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    async fetchAnalyticsDataByAffiliate() {
      this.progress = true;
      this.analyticsReportData = null;
      const body = {
        id_affiliate: this.idAffiliate,
        date_start: this.rangeDate.data_inicio,
        date_final: this.rangeDate.data_final,
        export: this.exportDoc,
      };

      if (this.exportDoc) {
        const extension = this.exportDoc;
        try {
          await this.$request
            .exportDoc(
              "/colab/financial/affiliateAnalyticsData",
              body,
              extension,
              this.rangeDate
            )
            .then(() => (this.errorMsg = null));
        } catch (err) {
          this.errorMsg = this.$t("noDataFount");
        } finally {
          this.progress = false;
        }
      } else {
        await this.$axios
          .post(
            "/colab/financial/affiliateAnalyticsData",
            this.$formdata(body)
          )
          .then((res) => {
            this.errorMsg = res.data.dados && null;
            this.analyticsReportData = res.data.dados;
          })
          .catch((err) => {
            this.errorMsg = err.response.data.messages.error;
          })
          .finally(() => (this.progress = false));
      }
    },
    fetchTotalActiveAffiliated() {
      this.$axios
        .post(
          "/colab/financial/totalActiveAffiliated",
          this.$formdata({
            id_affiliate: this.idAffiliate,
          })
        )
        .then((res) => {
          this.totalActiveAffiliated = res.data.dados.total_actives_affiliated;
        })
        .catch((err) => {
          this.errorMsg = err.response.data.messages.error;
        });
    },
    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
    handleColorStatus(status) {
      const map = { 0: "red", 1: "green", 2: "orange", 6: "grey" };
      return map[status];
    },
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
    getPortugueseMoney(value) {
      return Number(value).toLocaleString("pt-BR");
    },
  },
  created() {
    this.errorMsg = null;
    this.affiliateData = {
      name: this.$route.params.name,
      status: this.$route.params.status,
    };
    this.fetchAnalyticsDataByAffiliate();
    this.fetchTotalActiveAffiliated();
  },
};
</script>
